import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import moment from "moment";

type props = {
  probeData: Array<common.ProbeData>;
};

const Graph = (props: props) => {
  const probeData = props.probeData;

  const xAxis = probeData.map((x) =>
    moment(x.dateTime).format("DD/MM/YY, H:MM:ss")
  );

  const temperatureData = probeData.map((x) => x.temperatureDisplay);
  const humidityData = probeData.map((x) => x.humidity);

  const hello = {
    options: {
      chart: {
        id: "basic-bar",
      },
      xaxis: {
        categories: xAxis,
      },
    },
    series: [
      {
        name: "Temperature",
        data: temperatureData,
      },
      // {
      //   name: "Humidity",
      //   data: humidityData
      // }
    ],
  };

  return (
    <React.Fragment>
      <Chart
        options={hello.options}
        series={hello.series}
        type="line"
        width="100%"
      />
    </React.Fragment>
  );
};

export default Graph;
